import { defineMessages } from 'react-intl';

const trns = defineMessages({
  noSearchResultHeader: {
    id: 't0jxGs',
    defaultMessage: 'За вашим запитом нічого не знайдено 😔'
  },
  noSearchResultMessage: {
    id: '/tHyCZ',
    defaultMessage: `
    Залиште свій номер телефону, ми допоможемо знайти товар або його аналог.
    `
  },
  noSearchResultFormNameFieldPlaceholder: {
    id: '5n2k8P',
    defaultMessage: 'Вкажіть ваше ім’я'
  },
  noSearchResultFormSubmit: {
    id: '4G6CgY',
    defaultMessage: 'Відправити запит'
  },
  requiredFieldLabel: {
    id: 'asJvhP',
    defaultMessage: "Обов'язкове полe"
  },
  incorrectPhoneNumberLabel: {
    id: 'kGmugO',
    defaultMessage: 'Поле повинно відповідати формі +380-XX-XXX-XX-XX'
  },
  incorrectPhoneCode: {
    id: 'XMx74P',
    defaultMessage: 'Некоректний код мобільного оператора'
  },
  notificationTitle: {
    id: 'v5yy2V',
    defaultMessage: 'Ваш запит відправлено!'
  },
  notificationMessage: {
    id: 'HLsrp0',
    defaultMessage: 'Ми з вами зв’яжемось найближчим часом.'
  }
});

export default trns;
